<br />
<div class="container" *ngIf="product$| async as product">
  <div class="row p-1">
    <div class="col-sm-12">
      <div class="product-image">
        <div class="rounded mx-auto text-center" style="cursor: pointer;">
          <img
            [src]="product.full_picture_url ? product.full_picture_url : './assets/img/placeholder-image.png'"
            class="img-fluid center-block"
          />
        </div>
        <div class="text-center" style="margin-top: 15px;">
          <button class="btn btn-primary" (click)="addToCart(product)">
            Aggiungi al Carrello
          </button>
        </div>
      </div>
    </div>
  </div>
<div class="row p-1">
    <div class="col-sm-12">
      <div class="product-detail">
        <h5 class="product-head">Dettagli Prodotto</h5>
        <table class="table" cellspacing="0" style="max-height: 28px;">
          <tbody>
            <tr>
              <th scope="row">Descrizione</th>
              <td>{{ product.description | titlecase }}</td>
            </tr>
            <tr>
              <th scope="row">Offerta minima</th>
              <td>€ {{ product.price }}</td>
            </tr>
            <tr>
              <th scope="row">Origine</th>
              <td>{{ product.product_details["origin"] | titlecase}}</td>
            </tr>
            <tr>
              <th scope="row">No. di statuine</th>
              <td>{{ product.product_details["n_items"] }}</td>
            </tr>
            <tr>
              <th scope="row">Altezza</th>
              <td>{{ product.product_details["height"] }} cm</td>
            </tr>
            <tr>
              <th scope="row">Disponibilità</th>
              <td>{{ product.quantity }}</td>
            </tr>
            <tr>
              <th scope="row">Aggiunto il </th>
              <td>{{ product.created_at | date }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</div>
